module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAANlJREFUOE/V0zFuQjEMBmA7x0CVoB39vPQGPQU7F+jC0gkxMFVMvUB7CubegTivWxFiYGJl8w8ZQPD6KhG9CUvZ7M+WkzB1DO5YT6UAq+oQwJuZPefmJQBXVfUBYAlgU9f14gpQ1W8iyudPuPsqhFC5+46Ze2b2SkRoAtMY47QNEJF3Iloz85OZjU/FNwGqmtEtgAGAn5TS12WT8w5yYnMCEZmEEH4B9M1s1pbzLyAiI2Z+YOZ9jHGeuxYBx6W+uPtjSunzNHIR0LbMOwBu+RfNmyp5yq1+Z+AAxxmDEe2t58kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ios-create-outline.png
// module id = 2626
// module chunks = 2